import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [], // each item = { id, name, price (number), quantity, image, ... }
  totalQuantity: 0,
};

const toNumber = (val) => {
  if (typeof val === "number") return val;
  if (typeof val === "string") {
    // remove non numeric chars and parse float
    const n = parseFloat(val.replace(/[^\d.-]/g, ""));
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
 addToCart: (state, action) => {
  const raw = action.payload;
  const itemPrice = toNumber(raw.price);

  // Unique key for each variant
  const variantKey = `${raw.id}-${raw.selectedWatt}-${raw.selectedPin}-${raw.selectedColor}`;

  const existing = state.items.find(
    (i) =>
      i.variantKey === variantKey
  );

  if (existing) {
    existing.quantity += 1;
  } else {
    const newItem = {
      ...raw,
      variantKey, // store unique key
      price: itemPrice,
      quantity: 1,
    };
    state.items.push(newItem);
  }

  state.totalQuantity = state.items.reduce((s, it) => s + it.quantity, 0);
},


    incrementQty: (state, action) => {
      const item = state.items.find((i) => i.id === action.payload);
      if (item) {
        item.quantity += 1;
      }
      state.totalQuantity = state.items.reduce((s, it) => s + it.quantity, 0);
    },

    decrementQty: (state, action) => {
      const item = state.items.find((i) => i.id === action.payload);
      if (item) {
        if (item.quantity > 1) {
          item.quantity -= 1;
        } else {
          // remove item when quantity hits 0
          state.items = state.items.filter((i) => i.id !== action.payload);
        }
      }
      state.totalQuantity = state.items.reduce((s, it) => s + it.quantity, 0);
    },

    removeFromCart: (state, action) => {
      state.items = state.items.filter((i) => i.id !== action.payload);
      state.totalQuantity = state.items.reduce((s, it) => s + it.quantity, 0);
    },

    clearCart: (state) => {
      state.items = [];
      state.totalQuantity = 0;
    },

    setQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const item = state.items.find((i) => i.id === id);
      if (item) {
        item.quantity = Math.max(0, quantity);
        if (item.quantity === 0) {
          state.items = state.items.filter((i) => i.id !== id);
        }
      }
      state.totalQuantity = state.items.reduce((s, it) => s + it.quantity, 0);
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  clearCart,
  setQuantity,
  incrementQty,
  decrementQty,
} = cartSlice.actions;

export default cartSlice.reducer;
